// data.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DataJrExchangeService {
    private storedLinkNames = new BehaviorSubject<string>('');
    linkNameClicked = this.storedLinkNames.asObservable();

    constructor() { }

    linkClickedByName(linkName: string) {
        this.storedLinkNames.next(linkName);
    }
}